"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* tslint:disable */
var node = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v2 = [v1];
  return {
    "kind": "Fragment",
    "name": "ArtistShows_artist",
    "type": "Artist",
    "metadata": null,
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "first",
      "type": "Int",
      "defaultValue": 4
    }, {
      "kind": "LocalArgument",
      "name": "last",
      "type": "Int",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "after",
      "type": "String",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "before",
      "type": "String",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "sort",
      "type": "PartnerShowSorts",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "status",
      "type": "String",
      "defaultValue": null
    }],
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "showsConnection",
      "storageKey": null,
      "args": [{
        "kind": "Variable",
        "name": "after",
        "variableName": "after",
        "type": "String"
      }, {
        "kind": "Variable",
        "name": "before",
        "variableName": "before",
        "type": "String"
      }, {
        "kind": "Variable",
        "name": "first",
        "variableName": "first",
        "type": "Int"
      }, {
        "kind": "Variable",
        "name": "last",
        "variableName": "last",
        "type": "Int"
      }, {
        "kind": "Variable",
        "name": "sort",
        "variableName": "sort",
        "type": "PartnerShowSorts"
      }, {
        "kind": "Variable",
        "name": "status",
        "variableName": "status",
        "type": "String"
      }],
      "concreteType": "ShowConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "pageInfo",
        "storageKey": null,
        "args": null,
        "concreteType": "PageInfo",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "hasNextPage",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "endCursor",
          "args": null,
          "storageKey": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "pageCursors",
        "storageKey": null,
        "args": null,
        "concreteType": "PageCursors",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "Pagination_pageCursors",
          "args": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "ShowEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Show",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "partner",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": [v0, {
              "kind": "InlineFragment",
              "type": "Partner",
              "selections": v2
            }, {
              "kind": "InlineFragment",
              "type": "ExternalPartner",
              "selections": v2
            }]
          }, v1, {
            "kind": "ScalarField",
            "alias": null,
            "name": "href",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "exhibition_period",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "cover_image",
            "storageKey": null,
            "args": null,
            "concreteType": "Image",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "cropped",
              "storageKey": "cropped(height:600,width:800)",
              "args": [{
                "kind": "Literal",
                "name": "height",
                "value": 600,
                "type": "Int!"
              }, {
                "kind": "Literal",
                "name": "width",
                "value": 800,
                "type": "Int!"
              }],
              "concreteType": "CroppedImageUrl",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "url",
                "args": null,
                "storageKey": null
              }]
            }, {
              "kind": "ScalarField",
              "alias": "__id",
              "name": "id",
              "args": null,
              "storageKey": null
            }]
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "city",
            "args": null,
            "storageKey": null
          }, v0]
        }]
      }]
    }, v0]
  };
}();

node.hash = '743ab15f22c8c693361d5035dc02e63c';
var _default = node;
exports.default = _default;
//# sourceMappingURL=ArtistShows_artist.graphql.js.map